import { render, staticRenderFns } from "./interview.vue?vue&type=template&id=31842bfc&scoped=true"
import script from "./interview.vue?vue&type=script&lang=js"
export * from "./interview.vue?vue&type=script&lang=js"
import style0 from "./interview.vue?vue&type=style&index=0&id=31842bfc&prod&lang=scss&scoped=true"
import style1 from "./interview.vue?vue&type=style&index=1&id=31842bfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31842bfc",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/product/interview.vue
// module id = null
// module chunks = 